/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionDataBlocks
 */
export interface QuestionDataBlocks {
    /**
     * 
     * @type {object}
     * @memberof QuestionDataBlocks
     */
    attachments: object;
    /**
     * 
     * @type {object}
     * @memberof QuestionDataBlocks
     */
    comments: object;
    /**
     * 
     * @type {object}
     * @memberof QuestionDataBlocks
     */
    history: object;
    /**
     * 
     * @type {object}
     * @memberof QuestionDataBlocks
     */
    sscData: object;
}

export function QuestionDataBlocksFromJSON(json: any): QuestionDataBlocks {
    return QuestionDataBlocksFromJSONTyped(json, false);
}

export function QuestionDataBlocksFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionDataBlocks {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attachments': json['attachments'],
        'comments': json['comments'],
        'history': json['history'],
        'sscData': json['ssc_data'],
    };
}

export function QuestionDataBlocksToJSON(value?: QuestionDataBlocks | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attachments': value.attachments,
        'comments': value.comments,
        'history': value.history,
        'ssc_data': value.sscData,
    };
}


